
window.namespace = function (ns) {
    for (var scope = window, tokens = ns.split("."), index = 0, len = tokens.length; index < len; index++) {
        var token = tokens[index];
        scope = scope[token] = scope[token] || { __namespace: true };
    }
};